webpackJsonp([185660770532129],{

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _list = __webpack_require__(46);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _services = __webpack_require__(27);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _shutterstock_ = __webpack_require__(58);
	
	var _shutterstock_2 = _interopRequireDefault(_shutterstock_);
	
	var _puzzle_logo = __webpack_require__(229);
	
	var _puzzle_logo2 = _interopRequireDefault(_puzzle_logo);
	
	var _banner = __webpack_require__(22);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServicesInCooperation = function ServicesInCooperation(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(_banner2.default, {
	      title: 'Dienstleistungen in Kooperation',
	      image: _shutterstock_2.default
	    }),
	    _react2.default.createElement(_list2.default, {
	      text: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            'Das klassische Leistungsspektrum der Wirtschaftspr\xFCfung k\xF6nnen wir mit unserem Kooperationspartnern aus dem ETL Netzwerk abdecken.'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            'F\xFCr juristische Fragen (insbesondere Gesellschaftsrecht, Familien- und Erbrecht, Arbeitsrecht) unterhalten wir Kontakte zu verschiedenen Anwaltskanzleien und Notaren.'
	          )
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          'F\xFCr weitergehende Fragen k\xF6nnen Sie uns gerne ansprechen.'
	        )
	      ),
	      icon: _puzzle_logo2.default
	    }),
	    _react2.default.createElement(_services2.default, {
	      taxAdvice: true,
	      businessAdvice: true,
	      servicesInCooperation: false,
	      accounting: true,
	      businessValuation: true
	    })
	  );
	};
	
	exports.default = ServicesInCooperation;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-dienstleistungen-in-kooperation-js-54969b9d1551cc893d5f.js